import { type Dispatch } from '@reduxjs/toolkit';
import { message } from '@repo/ui';
import nodeService from 'automations/services/nodeService';
import { type RootState } from 'automations/store';
import { handleNodeDelete } from 'automations/store/reactFlowSlice';

import { didNodeSyncToServer } from './node';

export const deleteNode = (nodeId: string) => async (
  dispatch: Dispatch<any>,
  getState: () => RootState,
) => {
  const node = getState().automations.flowNodes.nodes.find((_node) => _node.id === nodeId);
  if (!node) return;

  const isNodeSaved = didNodeSyncToServer(node);

  if (isNodeSaved) {
    const response = await dispatch<any>(nodeService.endpoints.deleteNode.initiate({ id: nodeId }));
    if (response.data?.success) {
      dispatch(handleNodeDelete(nodeId));
    } else {
      message.error('Failed to delete node');
    }
  } else {
    dispatch(handleNodeDelete(nodeId));
  }
};
